import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from 'styled-components'
import getTheme from '../../styled/theme'

import { ConfirmModal, ConfirmContent, ConfirmMessage, ConfirmButtons } from '../../styled/confirm-modal'
import { PrimaryButton } from '../../styled/button'

const isDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches

const preventThen = (e, fn) => {
  e.preventDefault()
  fn()
}

const ConfirmDialog = ({ show, proceed, cancel, confirmation, confirmLabel = 'Yes', cancelLabel = 'Cancel', ok = false }) => (
  <ConfirmModal show={show}>
    <ThemeProvider theme={getTheme(isDarkMode ? 'dark' : '')}>
      <ConfirmContent>
        <ConfirmMessage>{confirmation}</ConfirmMessage>
        <ConfirmButtons>
          {ok && <PrimaryButton onClick={(e) => preventThen(e, proceed)}>Close</PrimaryButton>}
          {!ok && (
            <>
              <PrimaryButton onClick={(e) => preventThen(e, proceed)}>{confirmLabel}</PrimaryButton>
              <PrimaryButton onClick={(e) => preventThen(e, cancel)}>{cancelLabel}</PrimaryButton>
            </>
          )}
        </ConfirmButtons>
      </ConfirmContent>
    </ThemeProvider>
  </ConfirmModal>
)

ConfirmDialog.propTypes = {
  show: PropTypes.bool,
  proceed: PropTypes.func,
  cancel: PropTypes.func,
  dismiss: PropTypes.func,
  confirmation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  ok: PropTypes.bool
}

export default ConfirmDialog
